import { NgModule } from '@angular/core';
import { AppIconComponent } from './components';

@NgModule({
  declarations: [AppIconComponent],
  imports: [],
  exports: [AppIconComponent],
})
export class AppIconModule {}
